import React from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import {Headings} from "@arctheme-components/elements/Headings/Headings";
import {Paragraph} from "@arctheme-components/elements/Paragraph/Paragraph";
import Avatar from "@arctheme-components/elements/Avatar/Avatar";
import {StarIcon} from "../TestimonialStar/TestimonialStar"
import {
    Image
} from "@arctheme-components/elements/Image/Image";

const GridLayout = ({ settings, blocks }) => {
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
    const { section } = settings;

    const showAvatar = false;
    return (
        <div className={'testimonials'}>
            <div className={'testimonials-top'}>
                <Headings text={section.title} type={'h2'}/>
                <Paragraph text={section.subtext}/>
            </div>

            <div
                className={`testimonials__container lg:grid-cols-` + blocks.length}
                style={{gridTemplateColumns: `repeat(${blocks.length}, minmax(0, 1fr))`}}
            >
                {blocks.map((blockItem, index) => (
                    <div key={`review-${index}`} className="testimonial">
                        <div className={'testimonial__ratings'}>
                            {(() => {
                                let rows = [];
                                for (let i = 0; i < blockItem.settings.star_rating; i++) {
                                    // @ts-ignore
                                    rows.push(<StarIcon key={`star-${i}`} className="text-yellow-400"/>);
                                }
                                return rows;
                            })()}
                        </div>

                        <div className="testimonial__quote"
                             dangerouslySetInnerHTML={{__html: blockItem.settings.blurb.replace(/\n/g, '<br />')}}
                        />

                        <div className={'testimonial-data'}>
                            {showAvatar && <div className="testimonial__image">
                                <Avatar
                                    imageUrl={'https://via.placeholder.com/150'}
                                    size={'50px'}
                                />
                            </div>}

                            {blockItem.settings.image &&
                                <div className={'testimonial__image'}>
                                    <Image imageUrl={blockItem.settings.image} alt={'review_image'}/>
                                </div>
                            }

                            <div className={'testimonial__details'}>
                                {blockItem.settings.author &&
                                    <p className="testimonial__author">{blockItem.settings.author}</p>
                                }
                                {blockItem.settings.subtext &&
                                    <p className="testimonial__subtext">
                                        {blockItem.settings.subtext}
                                    </p>
                                }
                            </div>
                        </div>
                    </div>
                ))}

            </div>
        </div>
    );
};

export default GridLayout;

